import { render, staticRenderFns } from "./FormFirstImage.vue?vue&type=template&id=1bc2b5e2"
import script from "./FormFirstImage.vue?vue&type=script&lang=js"
export * from "./FormFirstImage.vue?vue&type=script&lang=js"
import style0 from "./FormFirstImage.vue?vue&type=style&index=0&id=1bc2b5e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports